<template>
  <el-menu-item v-bind="$attrs" v-on="$listeners">
    <slot></slot>
    <slot name="title"></slot>
  </el-menu-item>
</template>
<script>
export default {
  name: "aia-menu-item"
};
</script>